import { render, staticRenderFns } from "./AgendaPrazos.vue?vue&type=template&id=0427f00a&scoped=true&"
import script from "./AgendaPrazos.vue?vue&type=script&lang=js&"
export * from "./AgendaPrazos.vue?vue&type=script&lang=js&"
import style0 from "./AgendaPrazos.vue?vue&type=style&index=0&id=0427f00a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0427f00a",
  null
  
)

export default component.exports